// Scroll-triggered animations utility
// Pure CSS animations with JavaScript intersection observer

export function initScrollAnimations() {
  // Only run on client side
  if (typeof window === 'undefined') return;

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // Observe all elements with scroll animation classes
  const animatedElements = document.querySelectorAll(`
    .scroll-fade-in,
    .scroll-slide-left,
    .scroll-slide-right,
    .scroll-scale-up
  `);

  animatedElements.forEach(el => {
    observer.observe(el);
  });

  return () => {
    observer.disconnect();
  };
}

// Initialize animations when DOM is ready
export function setupScrollAnimations() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }
}
